<template>
  <v-parallax
    eager
    cover
    :src="require('@/assets/imagens/background_login.png')"
    class="parallax-overlay"
  >
    <v-container
      height="100vh"
      class="d-flex justify-center align-center"
      width="100vw"
    >
      <v-row class="login-card-row" align="center" justify="center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <v-card class="elevation-10 login-card" rounded="xl">
            <v-card-text>
              <div class="d-flex flex-column align-center mb-4">
                <v-img
                  :src="require('@/assets/imagens/FundoClaro_Horizontal.png')"
                  width="250"
                  height="60"
                  class="mb-4"
                  eager
                />
                <h2 class="login-title">Bem-vindo!</h2>
                <span class="login-subtitle">Acesse o sistema de Licenças</span>
              </div>
              <v-form ref="form" v-model="valid" @submit.prevent="login">
                <v-text-field
                  validate-on="blur"
                  class="mb-3"
                  variant="outlined"
                  v-model="email"
                  label="E-mail"
                  prepend-inner-icon="mdi-email"
                  required
                  :rules="[rules.required, rules.email]"
                />
                <v-text-field
                  validate-on="blur"
                  class="mb-4"
                  variant="outlined"
                  v-model="password"
                  label="Senha"
                  prepend-inner-icon="mdi-lock"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="togglePassword"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  :rules="[rules.required, rules.minLength(6)]"
                />
                <v-btn
                  type="submit"
                  block
                  :loading="loading"
                  color="primary"
                  size="large"
                  class="mb-2"
                  rounded
                >
                  Entrar
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-parallax>
</template>

<script>
import rulesMixin from "@/mixins/rulesMixin";
import api from "@/services/api";

export default {
  mixins: [rulesMixin],
  data: () => ({
    email: "",
    password: "",
    showPassword: false,
    loading: false,
    valid: false,
  }),
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        const response = await api.post("/login/", {
          email: this.email,
          senha: this.password,
        });
        // Salva o token no localStorage
        sessionStorage.setItem("token", response.data.acess_token);
        // Redireciona para a home
        this.$router.push({ name: "home" });
      } catch (error) {
        let message = "Ocorreu algum problema.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.detail
        ) {
          message = error.response.data.detail;
        }
        alert(message);
        console.error("Erro ao realizar login:", error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.parallax-overlay {
  position: relative;
}

.parallax-overlay::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.v-container {
  position: relative;
  z-index: 2;
}

.login-card-row {
  min-height: 100vh;
}

.login-card {
  position: relative;
  z-index: 3;
  padding: 32px 24px 24px 24px;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 24px;
}

.login-title {
  color: #1976d2;
  font-weight: 700;
  margin-bottom: 0;
}

.login-subtitle {
  color: #6f6f6f;
  font-size: 1.1rem;
  margin-bottom: 16px;
}

.v-btn {
  font-weight: 600;
  letter-spacing: 1px;
}
</style>
